import React from 'react';
import { withFirebase } from '../Firebase';
import { Button } from 'antd';
const SignOutButton = ({ firebase }) => (
    <Button type="primary" onClick={firebase.doSignOut}>
        Sign Out
    </Button>
);
export default withFirebase(SignOutButton);